import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { FetchMauOverageCostResponseActionPayload } from '../types';

const FetchMauOverageCost = new ReduxAsyncAction<'FETCH_MAU_OVERAGE_COST', void, FetchMauOverageCostResponseActionPayload>(
  'FETCH_MAU_OVERAGE_COST'
);

FetchMauOverageCost.registerRequest(async () => {
  const URI = '/v1/usage/mau/overage-cost';

  try {
    const overageCost = await dash_api.get<number>(URI);
    return overageCost;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_OVERAGE_COST = FetchMauOverageCost.actionNamespaceConstants;

export const fetchMauOverageCost = FetchMauOverageCost.request;

export type FetchMauOverageCostResponseAction = Action<typeof FETCH_MAU_OVERAGE_COST.response> & {
  data: FetchMauOverageCostResponseActionPayload;
};
